import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import UnderButtonNav from '../components/UnderButtonNav.jsx';
import StarBorder from '../components/StarBorder';
import carInterior from '../images/back-3.jpeg';

export default function Home() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="min-h-screen bg-[#030303] text-slate-100 font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      {/* ====================== HERO ====================== */}
      <section className="relative min-h-screen flex items-center overflow-hidden pb-24 md:pb-0">
        <div className="absolute inset-0 z-0">
          <img
            src={carInterior}
            alt="Luxury car"
            className="w-full h-full object-cover object-[75%_center]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#030303] via-[#030303]/70 to-transparent" />
          <div className="absolute inset-0 bg-black/20" />
        </div>

        <div className="absolute inset-0 grid-overlay opacity-30 z-10 pointer-events-none" />

        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[800px] h-[800px] red-aura z-10 opacity-40" />

        <div className="relative z-20 max-w-screen-2xl mx-auto px-8 w-full pt-24">
          <div className="glass-panel pulse-glow-border p-4 md:p-8 lg:p-12 rounded-[32px] max-w-2xl backdrop-blur-[30px] shadow-[0_0_60px_rgba(184,151,90,0.15)] mx-4 md:mx-0" style={{ background: 'rgba(10,10,10,0.3)' }}>
            <div className="space-y-4 md:space-y-8">
              <div className="flex items-center gap-3">
                <div className="h-px w-10 bg-gold" />
                <span className="text-[10px] uppercase tracking-[0.4em] font-black text-gold">
                  Автошкола Премиум 2026
                </span>
              </div>

              <h1 className="hero-title text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black uppercase leading-tight">
              ПОРА ПОЛУЧИТЬ<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400">ПРАВА</span>
              </h1>

              <p className="text-lg md:text-xl text-slate-300 font-light max-w-md leading-relaxed">
                Станьте водителем с нами: любые категории прав, опытные инструкторы, гибкий график и индивидуальный подход.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link
                  to="/courses"
                  className="px-10 py-5 bg-primary text-white font-black rounded-full neon-glow-red uppercase tracking-widest text-sm hover:shadow-[0_0_50px_rgba(225,29,72,0.5)] transition-all"
                >
                  Начать обучение
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                {[
                  { num: '6+', label: 'Лет опыта' },
                  { num: '8+', label: 'Автомобилей' },
                ].map((item) => (
                  <div key={item.label} className="glass-card p-4 rounded-xl flex flex-col items-center text-center">
                    <div className="text-3xl font-black text-white">{item.num}</div>
                    <div className="text-[10px] uppercase tracking-widest text-slate-400 mt-1">{item.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ====================== ПРЕИМУЩЕСТВА ====================== */}
      <section className="py-32 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-8">
          <div className="mb-20 text-center md:text-left">
            <h2 className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter mt-2">
              ПРЕИМУЩЕСТВА
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { icon: '📋', title: 'Лицензия ГИБДД', desc: 'Официальная аккредитация и полное соответствие стандартам' },
              { icon: '🚗', title: 'Новый автопарк', desc: 'Современные автомобили' },
              { icon: '👨‍🏫', title: 'Опытные инструкторы', desc: 'Профессионалы с многолетним стажем' },
              { icon: '⏰', title: 'Гибкий график', desc: 'Занятия в удобное для вас время, включая выходные' },
            ].map((item) => (
              <StarBorder
                key={item.title}
                color="#b8975a"
                speed="3s"
                className="hover:translate-y-[-8px] transition-all duration-400 flex flex-col h-full"
              >
                <div className="text-5xl mb-6 text-primary">{item.icon}</div>
                <h3 className="text-2xl font-black uppercase tracking-tight mb-4 group-hover:text-gold transition-colors">
                  {item.title}
                </h3>
                <p className="text-slate-400 leading-relaxed flex-grow">
                  {item.desc}
                </p>
              </StarBorder>
            ))}
          </div>
        </div>
      </section>

      {/* ====================== РАЗВОРАЧИВАЕМЫЙ SEO-БЛОК ====================== */}
      <section className="py-8 bg-[#1b1b1b] border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-8">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full flex items-center justify-center gap-3 py-4 text-slate-400 hover:text-primary transition-colors group"
          >
            <span className="text-sm uppercase tracking-wider">
              Подробнее об автошколе
            </span>
            <svg
              className={`w-5 h-5 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          <div className={`overflow-hidden transition-all duration-500 ${isExpanded ? 'max-h-[2000px] opacity-100 mt-8' : 'max-h-0 opacity-0'}`}>
            <div className="bg-black/30 rounded-2xl p-6 md:p-8">
              <div className="space-y-4 text-slate-300 leading-relaxed">
                <h3 className="text-2xl font-bold text-primary mb-4">Почему выбиру АвтоЛидер?</h3>
                
                <p><strong className="text-white">Автошкола «АвтоЛидер»</strong> — лидер по <strong className="text-primary">обучению вождению в Луганске</strong>. Мы успешно готовим водителей категорий A, B, C. Наши <strong>инструкторы по вождению</strong> — профессионалы с многолетним стажем, которые находят индивидуальный подход к каждому ученику.</p>
                
                <p>Курс включает в себя <strong>теоретическую подготовку и практические занятия на современных автомобилях</strong>. Мы предлагаем <strong>обучение на механике и автомате</strong>, <strong>гибкий график</strong> (включая выходные) и доступные <strong>цены на обучение</strong>.</p>
                
                <p><strong>Как сдать на права</strong> с первого раза? В автошколе АвтоЛидер мы используем современные методики обучения, проводим <strong>подготовку к экзаменам в ГИБДД</strong> и помогаем ученикам чувствовать себя уверенно за рулем. Наша <strong>лицензия ГИБДД</strong> подтверждает качество образования.</p>
                
                <p className="text-sm text-slate-400 italic">Запишитесь на <strong>курсы вождения в Луганске</strong> прямо сейчас — откройте для себя свободу передвижения с АвтоЛидер!</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ====================== CTA ====================== */}
      <section className="py-24 relative bg-[#050505]">
        <div className="max-w-screen-2xl mx-auto px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-5xl md:text-7xl font-black leading-tight italic mb-8 tracking-tighter">
              Авто<span className="text-primary">лидер</span> — <span className='underline'>твой</span> путь к правам
            </h2>

            <p className="text-xl text-slate-300 mb-12 max-w-3xl mx-auto">
              Научим водить безопасно и уверенно.
            </p>

            <Link
              to="/about"
              className="inline-block px-16 py-6 bg-primary text-white font-black text-lg uppercase tracking-widest rounded-full neon-glow-red hover:shadow-[0_0_60px_rgba(225,29,72,0.4)] transition-all"
            >
              Как начать?
            </Link>
          </div>
        </div>
      </section>

      <BottomNav />
      <UnderButtonNav />
    </div>
  );
}
// Сreated and developed by Marudami
